//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    font-size: 10px;
    font-weight: 600;
    color: ${colors.secondary20};
    padding: 0 3px 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const MultiValueLabel = (props) => {
  const text = props.data.shortLabel || props.data.label
  return (
    <StyledWrapper {...props.innerProps}>
      {text}
    </StyledWrapper>
  )
}

MultiValueLabel.propTypes = {
  innerProps: PropTypes.object,
  children: PropTypes.node,
  data: PropTypes.object,
}

export default MultiValueLabel
